const currency = {
  currency: 'Currency',
  addCurrency: 'Add Currency',
  editCurrency: 'Edit Currency',
};
export default currency;
